"use client"

import React, { useState } from "react"
import { Button } from "@abraxas/ui/ui"
import { PageTitle } from "@/shared/components/PageTitle"
import { WalletGate } from "@/shared/components/WalletGate"
import { NFTsGrid } from "./NFTsGrid"
import { CreateListingModal } from "./CreateListingModal"

const MarketplacePage = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)

  const handleCreateSuccess = () => {
    setIsCreateModalOpen(false)
  }

  return (
    <div className="min-h-screen bg-linear-to-b from-purple-900 to-black">
      <div className="container mx-auto px-4 py-8">
        <PageTitle
          title="Trait Market"
          subtitle="Buy, sell, and trade cLockS and Phygital NFTs"
          className="text-center"
        />

        <div className="mb-8 flex justify-center">
          <WalletGate>
            <Button
              size="large"
              className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold"
              onClick={() => setIsCreateModalOpen(true)}
            >
              Create Listing
            </Button>
          </WalletGate>
        </div>

        <div className="mb-6">
          <div className="flex flex-wrap gap-4 justify-center items-center">
            <div className="flex items-center gap-2">
              <span className="text-white font-medium">Filters:</span>
              <Button variant="outlined" size="small">
                All
              </Button>
              <Button variant="outlined" size="small">
                cLockS
              </Button>
              <Button variant="outlined" size="small">
                Phygitals
              </Button>
            </div>

            <div className="flex items-center gap-2">
              <span className="text-white font-medium">Sort by:</span>
              <select className="bg-black/50 text-white border border-white/20 rounded px-3 py-1">
                <option>Newest first</option>
                <option>Price: Low to High</option>
                <option>Price: High to Low</option>
              </select>
            </div>
          </div>
        </div>

        <NFTsGrid />

        <CreateListingModal
          open={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
          onSuccess={handleCreateSuccess}
        />
      </div>
    </div>
  )
}

export default MarketplacePage
